import React, { useState, useEffect, Suspense } from 'react'; // Suspense ensures that lazy-loaded components render correctly. lazy components come from ./routes
import { Route, Routes, Link } from 'react-router-dom';
import routes from "./routes";
import ServitechLogoColor from './svg/ServiTechColor.svg'
import config from './config'

import 'bootstrap/dist/css/bootstrap.min.css'
import './styles.css'
import LoginComponent from './LoginComponent';

const AppWrapper = () => {

    const [userEmail, setUserEmail] = useState("");
    const [userToken, setUserToken] = useState("");
    const [additionalListItems, setAdditionalListItems] = useState(null);

    const handleLogOut = async (e) => {
        e.preventDefault()
        clearEmailToken()
        clearAccessToken()
        setAdditionalListItems(null)
    }

    const getEmail = () => {
        const email = localStorage.getItem('email');
        return (email);
    }
    const setEmail = (email) => {
        localStorage.setItem('email', email);
        setUserEmail(email);
    }

    const clearEmailToken = () => {
        localStorage.removeItem('email');
        setUserEmail("");
    }

    const getAccessToken = () => {
        const token = localStorage.getItem('token');
        return (token);
    }
    const setAccessToken = (token) => {
        localStorage.setItem('token', token);
    }

    const clearAccessToken = () => {
        localStorage.removeItem('token');
    }

    const email = getEmail();
    const token = getAccessToken();

    useEffect(() => {
        if (token) {
            setUserToken(token);
        }
    }, [token]);

    useEffect(() => {
        if (email) {
            setUserEmail(email);
        }
    }, [email]);


    console.log(userEmail, userToken)

    return (
        <div style={{ height: "100vh" }}>
            <nav className="navbar ST-navbar fixed-top">
                <div className="container-fluid">
                    <div>
                        {/* eslint-disable-next-line */}
                        <a className="navbar-brand me-0" href="#"><img src={ServitechLogoColor} height="35px" /></a>
                    </div>
                    <div className="service-title">Employee Directory</div>
                    <div className="pe-0">
                        {/* eslint-disable-next-line */}
                        <a className="navbar-nav" data-bs-toggle="dropdown">
                            <i className="bi bi-three-dots" style={{ "fontSize": "1.5rem", "color": "#000000", "cursor": "pointer" }}></i>
                        </a>
                        <ul className="me-0 dropdown-menu dropdown-menu-end" id="three-dot-menu">

                            {additionalListItems}

                            <li><a className="dropdown-item" href={config.urls.assets}>Asset Manager</a></li>
                            <li><a className="dropdown-item" href={config.urls.employees}>Employee Manager</a></li>
                            <li><a className="dropdown-item" href="https://cropfile.servitech.com">The Crop File</a></li>
                            <li><a className="dropdown-item" href="https://labreports.servitechlabs.com/">Lab Reports</a></li>
                            <li><a className="dropdown-item" href="https://intranet.servitech.com">ServiTech Intranet</a></li>

                            <li><hr className="dropdown-divider" /></li>

                            <li className="dropdown-item" onClick={((e) => handleLogOut(e))}><Link to="/login" style={{ color: "black", textDecoration: "none" }}>Logout</Link></li>

                        </ul>
                    </div>
                </div>
            </nav>
            <div className="content-routes">
                <Suspense fallback={<div>Loading...</div>}> {/* <-- this line prevents React from throwing an error while waiting for the import to resolve. */}
                    <Routes>
                        {routes.map(({ path, component: Component }) =>
                        (
                            <Route key={path} path={path} element={(userEmail && userToken) ? <Component
                                setEmail={setEmail}
                                setAccessToken={setAccessToken}
                                getEmail={getEmail}
                                getAccessToken={getAccessToken}
                                setAdditionalListItems={setAdditionalListItems}
                            /> : <LoginComponent
                                setEmail={setEmail}
                                setAccessToken={setAccessToken}
                                getEmail={getEmail}
                                getAccessToken={getAccessToken}
                            />} />
                        )
                        )}
                    </Routes>
                </Suspense>
            </div>
        </div>
    );
}

export default AppWrapper;
